module.exports = __webpack_public_path__ + "img/hzfp24.7a99ccad.png";